module.exports = __webpack_public_path__ + "img/landing-shot.f5f24c5c.jpg";